"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useItemDraft = useItemDraft;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var item_1 = require("../../../../../reducers/slices/item/item");
function useItemDraft() {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.itemState; }), selectedItem = _a.selectedItem, file = _a.file, isEdited = _a.isEdited, errors = _a.errors;
    var markEdited = (0, react_1.useCallback)(function () {
        if (!isEdited)
            dispatch((0, item_1.setIsEdited)(true));
    }, [dispatch, isEdited]);
    var updateItem = (0, react_1.useCallback)(function (changes) {
        dispatch((0, item_1.setSelectedItem)(__assign(__assign({}, selectedItem), changes)));
        markEdited();
    }, [dispatch, selectedItem, markEdited]);
    var updateBadge = (0, react_1.useCallback)(function (changes) {
        var _a;
        var badge = (_a = selectedItem.badge) !== null && _a !== void 0 ? _a : item_1.defaultBadgeSettings;
        updateItem({ badge: __assign(__assign(__assign({}, badge), changes), { theme: __assign(__assign({}, badge.theme), changes.theme) }) });
    }, [selectedItem, updateItem]);
    var updateFile = (0, react_1.useCallback)(function (nextFile) {
        dispatch((0, item_1.setFile)(nextFile));
        dispatch((0, item_1.setFileEdited)(true));
        markEdited();
    }, [dispatch, markEdited]);
    return { selectedItem: selectedItem, file: file, errors: errors, updateItem: updateItem, updateBadge: updateBadge, updateFile: updateFile };
}
